module.exports = __webpack_public_path__ + "img/wh_red_logo_header.9516fb01.png";